export class CarouselPagination extends HTMLElement {
  connectedCallback() {
    this.hidden = false;

    this.classList.add('glide__arrows');
    this.setAttribute('data-glide-el', 'controls[nav]');

    this.querySelectorAll('button').forEach((button, index) => {
      button.setAttribute('data-glide-dir', `=${index}`);
    });
  }

  disconnectedCallback() {
    this.hidden = true;

    this.classList.add('glide__arrows');
    this.removeAttribute('data-glide-el', 'track');

    this.querySelectorAll('button').forEach((button) => {
      button.removeAttribute('data-glide-dir');
    });
  }
}